module.exports = __webpack_public_path__ + "static/media/dialog-banner-logo-ci.d981f555.png";